import { apiSlice } from "@/shared/api/api-slice"

import type {
  BalanceResponse,
  GetBalanceRequest,
  GetDistributionChatsRequest,
  GetDistributionChatsResponse,
  RawGetDistributionChatsResponse
} from "./types"

export const getBalanceApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["Balance", "DistributionChats"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getBalance: builder.query<BalanceResponse, GetBalanceRequest>({
        query: ({ chatId }) => `/api/v1/balance/info?chat_id=${chatId}`,
        providesTags: (_result, _error, { chatId }) => [{ type: "Balance" as const, id: `CHAT_${chatId}` }]
      }),
      getDistributionChats: builder.query<GetDistributionChatsResponse, GetDistributionChatsRequest>({
        query: request =>
          request?.managedOnly === false
            ? "/api/v1/balance/group-distribution/chats?managed_only=false"
            : "/api/v1/balance/group-distribution/chats",
        transformResponse: (raw: RawGetDistributionChatsResponse): GetDistributionChatsResponse => ({
          chats: raw.chats.map(chat => ({
            chat_id: chat.chat_id,
            purchased_balance: chat.purchased_balance,
            title: chat.title,
            username: chat.username,
            total_participants: chat.total_participants,
            avatar_url: chat.avatar_url,
            avatar_file_unique_id: chat.avatar_file_unique_id,
            avatar_state: chat.avatar_state,
            role: chat.is_owner ? "owner" : chat.is_admin ? "admin" : "member"
          }))
        }),
        providesTags: ["DistributionChats"]
      })
    })
  })

export const { useGetBalanceQuery, useGetDistributionChatsQuery } = getBalanceApi
